import { pipe, prop } from 'ramda';

import { authSelector } from '../selectors';

// eslint-disable-next-line import/prefer-default-export
export const resetPasswordSelector = pipe(authSelector, prop('resetPassword'));
